import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { onProfileEditorInternal, onOpenProfileEditor } from 'owa-nova-actions';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaNovaProfileEditor" */ './lazyIndex'),
    { name: 'OwaNovaProfileEditor' }
);

registerLazyOrchestrator(onOpenProfileEditor, lazyModule, m => m.openProfileEditor);
registerLazyOrchestrator(onProfileEditorInternal, lazyModule, m => m.profileEditorInternal);

export const ProfileEditorAsync: typeof lazyIndex.ProfileEditorWrapper = createLazyComponent(
    lazyModule,
    m => m.ProfileEditorWrapper
);
